export enum AddressStatus {
  CHECKED = 'CHECKED',
  WARNING = 'WARNING'
}
